import { z } from "zod";

export enum EAbusiveReportType {
  VISIT = "VISIT",
  INTERVENTION = "INTERVENTION",
}

export const abusiveReportTypeSchema = z.nativeEnum(EAbusiveReportType);

export type TAbusiveReportType = z.infer<typeof abusiveReportTypeSchema>;
